import React from "react";
import { LoadioContentProfileEditTemplate } from "themes/administration/loadio/pages";
import { LoadioContentProfileEditViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new LoadioContentProfileEditViewStore(rootStore, componentProps),
    "loadioContentProfileEditViewStore"
)
class LoadioContentProfileEdit extends React.Component {
    render() {
        return <LoadioContentProfileEditTemplate {...this.props} />;
    }
}

export default LoadioContentProfileEdit;
